/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useContext, useEffect } from "react";
import {
 FaChevronLeft, FaLink, FaSync, FaTrashAlt
} from "react-icons/fa";
import { useHistory } from 'react-router-dom';
import Footer from "../components/Footer";
import Logo from "../components/Logo";
import Main from "../components/Main";
import NavBar from "../components/NavBar";
import ProjectCard from "../components/ProjectCard";
import Skill from "../components/Skill";
import {projects} from "../data/projects";
import Startups from "../data/startups.json";
import Aos from "aos";
import "aos/dist/aos.css";


function ProfilePage() {
  const history = useHistory();
  useEffect(() => {
    Aos.init();
  
  }, [])

  return (
    <div className=" md:p-10 md:pt-0 p-2 bg-gray-100 w-full">
      {/* <NavBar className="navbar-browse w-full">
        <Logo />

      </NavBar> */}

      <div className="flex flex-col gap-4">
        <Main />
        <Skill />
    
        <div className="p-4 md:p-12 mx-auto w-full bg-white lg:py-4 border rounded-lg ">
        <h2 class="flex justify-center font-sans text-3xl font-bold leading-none tracking-tight text-center text-gray-900 b-6 sm:text-4xl md:mx-auto" data-aos="fade-right" data-aos-duration="500">
            <span class="relative">Projects</span> </h2>
        <div class="grid max-w-lg gap-5 mx-auto mt-12 md:grid-cols-2 lg:grid-cols-3 md:max-w-none">
          {projects.map((x, index) => <div data-aos="zoom-in-up" data-aos-duration={200}><ProjectCard data={x}   /></div>)}

        </div>

</div>

<div class="py-12 bg-gray-100">
      <div className="p-4 md:p-12 mx-auto w-full bg-white lg:py-4 border rounded-lg ">
        <h2
            class="flex justify-center font-sans text-3xl font-bold leading-none tracking-tight text-center text-gray-900 b-6 sm:text-4xl md:mx-auto">
            <span class="relative">My Start Ups</span> </h2>

        <div class="grid max-w-lg gap-5 mx-auto mt-12 md:grid-cols-2 lg:grid-cols-3 md:max-w-none">
          {Startups.map((x) => <ProjectCard data={x} />)}

        </div>
    </div>
    
</div>
      </div>
    
      <Footer />
    </div>
  );
}

export default ProfilePage;
